// REACT_APP_API_URL set to '' (empty) makes all requests relative to the page
// origin, so the CRA dev-server proxy (package.json "proxy") carries them to
// the backend — required for LAN dev where only port 3000 is reachable.
const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000';

export const API_CONFIG = {
  BASE_URL: API_URL,
  UPLOADS_BASE_URL: `${API_URL}/uploads`,
  TIMEOUT: 30000, // 30 seconds
  WITH_CREDENTIALS: true
};

// Validate production configuration
if (process.env.NODE_ENV === 'production' && !API_CONFIG.BASE_URL.startsWith('https://')) {
  console.error('Production API must use HTTPS');
  throw new Error('Invalid API configuration for production');
}

export default API_CONFIG;

